<template>
  <div class="inventory">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>
      <button class="btn fixed_btn" @click="saveProfile()">Save Profile</button>
      <div class="card">
        <p class="title">Your Profile</p>
        <div class="inputs" v-if="user">
          <div class="input">
            <label>First Name</label>
            <input v-model="user.first_name" />
          </div>
          <div class="input">
            <label>Last Name</label>
            <input v-model="user.last_name" />
          </div>
          <div class="input">
            <label>Email Address</label>
            <input v-model="user.primary_contact_info.email" />
          </div>
          <div class="input">
            <label>Phone Number</label>
            <input v-model="user.primary_contact_info.phone" />
          </div>
          <div class="input">
            <label>Change Password</label>
            <input v-model="auth.password" />
          </div>
          <div class="input">
            <label>Confirm New Password</label>
            <input v-model="auth.confirm" />
          </div>
        </div>
        <button @click="saveProfile()" class="btn">Save Profile</button>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import firebase from "firebase";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "profile",
  data() {
    return {
      user: null,
      auth: {
        password: null,
        confirm: null,
      },
      changeAuthCred: functions.httpsCallable("editUser"),
    };
  },
  created() {
    this.user = this.$store.state.reseller;
  },
  methods: {
    saveProfile() {
      let auth = this.auth;
      if (auth.password && auth.confirm) {
        if (auth.password == auth.confirm) {
          let loader = this.$loading.show({
            container: false,
            canCancel: false,
          });
          this.changeAuthCred({
            payload: {
              password: auth.password,
            },
            uid: this.user.primary_contact_info.uid,
          }).then(() => {
            loader.hide();
            this.auth = {
              password: null,
              confirm: null,
            };
            Swal.fire(
              "Update Succesful",
              "Your Password has been updated",
              "success"
            );
          });
        } else {
          this.auth.confirm = null;
          Swal.fire("Password doesn't match");
        }
      }
    },
  },
};
</script>

<style lang="scss"></style>
